export default "__VITE_ASSET__DP9T2PIg__"